import { cn } from '@/lib/utils/tailwind';

import { CardContainerProps } from './types';

export const Body = ({ children, className }: CardContainerProps) => (
  <div className={cn(className)}>{children}</div>
);
